export const SHEETS_CONFIG = {
  API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || '',
  CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  SPREADSHEET_ID: process.env.REACT_APP_SPREADSHEET_ID || '',
  DISCOVERY_DOCS: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
  SCOPES: 'https://www.googleapis.com/auth/spreadsheets',
};

export const SHEET_NAMES = {
  CUSTOMERS: 'Customers',
  TASKS: 'Onboarding_Tasks',
  PROGRESS: 'Customer_Progress',
  HEALTH_SCORES: 'Health_Scores',
  ACTIVITY_LOG: 'Activity_Log',
  PRICING_SLABS: 'Pricing_Slabs',
  TRANSACTIONAL_PRICING_SLABS: 'Transactional_Pricing_Slabs',
};

export const RANGES = {
  CUSTOMERS: 'Customers!A:H',
  TASKS: 'Onboarding_Tasks!A:F',
  PROGRESS: 'Customer_Progress!A:F',
  HEALTH_SCORES: 'Health_Scores!A:D',
  ACTIVITY_LOG: 'Activity_Log!A:J',
  PRICING_SLABS: 'Pricing_Slabs!A:I',
  TRANSACTIONAL_PRICING_SLABS: 'Transactional_Pricing_Slabs!A:J',
};